export const META_BOP = 'BOP';
export const META_BROWSE = 'BROWSE';
export const META_CATEGORY = 'CATEGORY';
export const META_SEARCH = 'SEARCH';

const replaceParameters = (string, params) =>
  string.replace(/\[[a-zA-z]*?\]/g, (name) => params[name] || '');

const getMeta = (metaField, pageMetaData, params) => {
  const metaString = pageMetaData && pageMetaData[metaField];

  if (metaString) {
    // Replaces [param] pattern with the value if provided
    return replaceParameters(metaString, params);
  }

  return null;
};

const prepareMetaParams = (params) => {
  const metaParams = {};
  for (const [key, value] of Object.entries(params)) {
    metaParams[`[${key}]`] = value;
  }
  return metaParams;
};

export const prepareFiltersAsParams = (filters) => {
  const { brandFilters = [], dietaryFilters = [], optionFilters = [], otherFilters = [] } = filters;
  return {
    brand: !!brandFilters.length && brandFilters.join(' '),
    dietary: !!dietaryFilters.length && dietaryFilters.join(' '),
    options: !!optionFilters.length && optionFilters.join(' '),
    otherFilters: !!otherFilters.length && otherFilters.join(' '),
  };
};

export const getPageMetaData = (pageKey, metaFromState) => {
  if (!metaFromState || !metaFromState.data || !metaFromState.data[pageKey]) {
    return null;
  }

  return metaFromState.data[pageKey];
};

export const getMetaTitle = (pageMetaData, params = {}) =>
  getMeta('title', pageMetaData, prepareMetaParams(params));

export const getMetaDescription = (pageMetaData, params = {}) =>
  getMeta('description', pageMetaData, prepareMetaParams(params));
